// @ts-nocheck
import { Badge, Box } from "@mui/material";
import PropTypes from "prop-types";
import { CiAt } from "react-icons/ci";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";

export default function NotesBadge({ unread, assigned, children }) {
  return (
    <Badge
      badgeContent={unread}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      overlap="circular"
      sx={{
        "& .MuiBadge-badge": {
          backgroundColor: "#D175B6",
          color: "#fff",
          right: "-0.15rem",
          bottom: "0.45rem",
          padding: "4px",
        },
      }}
    >
      <Badge
        badgeContent={
          assigned ? <CiAt strokeWidth={"1.5px"} color={"white"} /> : null
        }
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        overlap="circular"
        sx={{
          "& .MuiBadge-badge": {
            backgroundColor: "#D175B6",
            color: "#fff",
            right: "-0.25rem",
            bottom: "-0.25rem",
            padding: "4px",
          },
        }}
      >
        <Box
          component="span"
          sx={
            unread || assigned
              ? {
                  "& svg": {
                    filter: `
      drop-shadow(0 0 4px ${getCssVariableHandler({ variableName: "--primary-pink-hex" })})
      drop-shadow(0 0 8px ${getCssVariableHandler({ variableName: "--primary-pink-hex" })})
      drop-shadow(0 0 12px rgba(255, 105, 180, 0.6))
    `,
                    transition: "filter 0.3s ease-in-out",
                    "&:hover": {
                      filter: `
        drop-shadow(0 0 6px ${getCssVariableHandler({ variableName: "--primary-pink-hex" })})
        drop-shadow(0 0 14px ${getCssVariableHandler({ variableName: "--primary-pink-hex" })})
        drop-shadow(0 0 20px rgba(255, 105, 180, 0.8))
      `,
                    },
                  },
                }
              : {}
          }
        >
          {children}
        </Box>
      </Badge>
    </Badge>
  );
}

export const ChatBadge = ({ totalUnread, children }) => {
  return (
    <Badge
      badgeContent={totalUnread}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      overlap="circular"
      sx={{
        "& .MuiBadge-badge": {
          backgroundColor: "#D175B6",
          color: "#fff",
          right: "-0.15rem",
          bottom: "0.45rem",
          padding: "4px",
          fontSize: "0.75rem",
          minWidth: "20px",
          height: "20px",
        },
      }}
    >
      <Box
        component="span"
        sx={
          totalUnread > 0
            ? {
                "& svg": {
                  filter: `
                    drop-shadow(0 0 4px ${getCssVariableHandler({ variableName: "--primary-pink-hex" })})
                    drop-shadow(0 0 8px ${getCssVariableHandler({ variableName: "--primary-pink-hex" })})
                    drop-shadow(0 0 12px rgba(255, 105, 180, 0.6))
                  `,
                  transition: "filter 0.3s ease-in-out",
                  "&:hover": {
                    filter: `
                      drop-shadow(0 0 6px ${getCssVariableHandler({ variableName: "--primary-pink-hex" })})
                      drop-shadow(0 0 14px ${getCssVariableHandler({ variableName: "--primary-pink-hex" })})
                      drop-shadow(0 0 20px rgba(255, 105, 180, 0.8))
                    `,
                  },
                },
              }
            : {}
        }
      >
        {children}
      </Box>
    </Badge>
  );
};
ChatBadge.propTypes = {
  totalUnread: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.any,
};

export const CustomNumberBadge = ({ number, sx }) => {
  return (
    <Badge
      badgeContent={number}
      overlap="circular"
      sx={{
        "& .MuiBadge-badge": {
          backgroundColor: "#D175B6",
          color: "#fff",
          right: "-0.75rem",
          bottom: "0.45rem",
          padding: "4px",
        },
        ...(sx || {}),
      }}
    />
  );
};
CustomNumberBadge.propTypes = {
  number: PropTypes.number,
  sx: PropTypes.object,
};

NotesBadge.propTypes = {
  unread: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  assigned: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.any,
};